import Progress from ".";
import useProgressStore from "../../redux/dispatcher/useProgressStore";

// Progress를 App.tsx에서 바로 사용하면, useProgressStore에 의해 axios 호출할 때마다 계속 rerendring밣생
const ProgressParents = ({ isOn }: { isOn: boolean }) => {
  const { progressState } = useProgressStore();
  return <Progress inProgress={isOn ? isOn : progressState.count > 0} />;
};

export default ProgressParents;
